import data from "../../shared/sharedData";

export default {
  name: "Appendix A.A - Foreign Worker Contact Information",
  pageInfo: {
    text: "<b><u>Note:</u></b> The foreign worker information in this section must be different from the attorney/agent information listed in Section C and <b><u>must be different</u></b> from the employer information listed in sections B and C, unless the employer’s job opportunity is for a live-in household domestic service worker.  Appendix A must be submitted with the Form ETA-9089 in order for the application to be considered complete.  If filing electronically, Appendix A will be available in the electronic filing system.  If filing by mail, the employer must download and submit the Form ETA-9089 – Appendix A, and all other required appendices.  <b><i>In accordance with 20 CFR 656.17(a), the Department will not certify incomplete applications.</i></b>  Applications and documents submitted by mail should include a cover page with the name, title, address, and phone number of the point of contact.  The cover page should also index the documents included in the mailing.",
    coloring: "grey",
  },
  sections: [
    {
      fields: [
        {
          widget: "InlineGroupPrefillerInput",
          prefillLabel: "Select a profile to populate this section",
          groupPrefillLabel: "Select a profile group to search for a worker",
          code: "B",
          prefill: {
            schema: "ForeignWorker",
            type: "foreign-worker",
            groupType: "foreign-worker-group",
            formName: "9089",
            formSection: "A.A",
          },
        },
        {
          label: `<b>Foreign Worker</b>`,
          widget: "label",
        },
        {
          code: "A.1",
          machine_name: "appAContLastName",
          widget: "text",
          label: "Foreign Worker's Last (family) Name",
          validate: [
            "required",
            "noNAs",
            {
              minLength: 2,
              message: "Last Name must contain at least 2 characters",
            },
          ],
          maxLength: 35,
          tooltip: `Enter the last (family) name of the foreign worker.  If the foreign worker has only one name, enter the name in this field and enter “FNU” (first name unknown) in the first name field.`,
        },
        {
          code: "A.2",
          machine_name: "appAContFirstName",
          widget: "text",
          label: "Foreign Worker's First (given) Name",
          validate: [
            "required",
            "noNAs",
            {
              minLength: 2,
              message: "First Name must contain at least 2 characters",
            },
          ],
          maxLength: 35,
          tooltip:
            "Enter the first (given) name of the foreign worker.  If the foreign worker has only one name, enter “FNU” (first name unknown) in this field.",
        },
        {
          code: "A.3",
          machine_name: "appAContMiddleName",
          widget: "text",
          label: "Foreign Worker's Middle Name(s)",
          validate: ["required"],
          maxLength: 35,
          tooltip: `Enter the full middle name of the foreign worker.  If the foreign worker does not have a middle name, enter “N/A.”`,
        },
      ],
    },
    {
      fields: [
        {
          label: `<b>Foreign Worker - Address</b>`,
          widget: "label",
        },
        {
          code: "A.4",
          machine_name: "appAContAddress1",
          widget: "text",
          label: "Address 1 (current)",
          validate: [
            "required",
            "noNAs",
            {
              minLength: 2,
              message: `Address 1 must contain at least 2 characters.`,
            },
          ],
          maxLength: 120,
          tooltip: `Enter the street address of the foreign worker’s current residence.`,
        },
        {
          code: "A.5",
          machine_name: "appAContAddress2",
          widget: "text",
          label:
            "<span>Address 2 <i>(apartment/suite/floor and number)</i>  §</span>",
          maxLength: 35,
          tooltip: `If additional space is needed for the street address, use this line.  If no additional space is needed, enter “N/A.”`,
        },
        {
          code: "A.9",
          label: "Country",
          machine_name: "appAContCountryId",
          widget: "select",
          selection: data.country,
          validate: ["required"],
          clearSchema: ["appAContStateId", "appAContProvince"],
          tooltip:
            "Enter the country of the foreign worker’s current residence. If the city and country of residence are the same, the name <u>must</u> still be entered in <u>both</u> fields.",
        },
        {
          code: "A.6",
          label: "City",
          machine_name: "appAContCity",
          widget: "text",
          tooltip: `Enter the city of the foreign worker’s current residence.  If the city and country of 
            residence are the same, the name <u>must</u> still be entered in <u>both</u> fields.`,
          disabled: true,
          disableWhenField: "appAContCountryId",
          validate: [
            "required",
            {
              minLength: 2,
              message: "City must contain at least 2 characters.",
            },
            "noNAs",
          ],
          maxLength: 35,
        },
        {
          code: "A.7",
          label: `State <span style="font-size:13.62px">*</span>`,
          machine_name: "appAContStateId",
          widget: "select",
          selection: data.state,
          state: true,
          maxLength: 35,
          disabled: true,
          disableWhenField: "appAContCountryId",
          isVisible: {
            when: "appAContCountryId",
            is: ["UNITED STATES OF AMERICA", "- Select -", ""],
            operator: "||",
            hideStyles: true,
          },
          validate: [
            {
              isRequired: "appAContCountryId",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "UNITED STATES OF AMERICA",
              },
            },
          ],
          tooltip:
            "Enter the state of the foreign worker’s current residence.  If no state, enter “N/A.”",
        },
        {
          code: "A.8",
          label: "Postal Code",
          machine_name: "appAContPostalCode",
          widget: "text",
          disabled: true,
          disableWhenField: "appAContCountryId",
          validate: [
            //"postal",
            {
              postalCountry: "appAContCountryId",
              needsFieldValues: true,
              extraData: {
                valueOf: "appAContCountryId",
              },
            },
            {
              isRequired: "appAContCountryId",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "UNITED STATES OF AMERICA",
              },
            },
          ],
          //minLength: 5,
          maxLength: 10,
          tooltip:
            "Enter the postal (zip) code of the foreign worker’s current residence.  If no postal code, leave blank.",
        },
        {
          code: "A.10",
          machine_name: "appAContProvince",
          widget: "text",
          label: "Province  §",
          validate: [
            {
              isRequired: "appAContCountryId",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "CANADA",
              },
            },
          ],
          maxLength: 25,
          tooltip: `Enter the province of the foreign worker’s current residence.  If no province, enter “N/A.”`,
        },
      ],
    },
    {
      fields: [
        {
          label: `<b>Foreign Worker - Citizenship</b>`,
          widget: "label",
        },
        {
          code: "A.11",
          machine_name: "appAContDOB",
          widget: "date",
          label: "Date of Birth (mm/dd/yyyy)",
          validate: ["required", "noNAs", "noFutureDate"],
          maxLength: 70,
          tooltip: `Enter the foreign worker's date of birth.  Use a MM/DD/YYYY format.`,
          //Allows prefill to update value without needing to rerender
          updateOnChange: true,
        },
        {
          code: "A.12",
          machine_name: "appAContAdmClassId",
          widget: "select",
          selection: data.classofAdmission,
          label: "Class of Admission",
          validate: ["required"],
          maxLength: 70,
          tooltip: `Enter the foreign worker’s class of admission at the time of filing (e.g., H-1B, H-2A, etc.).  If no class of admission, enter “N/A.”`,
        },
        {
          code: "A.13",
          machine_name: "appAContAlienReg",
          widget: "text",
          label: "Alien Registration Number (A#) (if applicable)",
          validate: ["required", "noNAs"],
          maxLength: 11,
          tooltip: `Enter the foreign worker’s alien registration number (A#) assigned by DHS.  If no alien registration number, enter “0” (zero).`,
        },
        {
          code: "A.14",
          machine_name: "appAContBirthCountryId",
          widget: "select",
          label: "Country of Birth",
          selection: data.country,
          validate: ["required", "noNAs"],
          maxLength: 70,
          tooltip: `Enter the foreign worker's country of birth.`,
        },
        {
          code: "A.15",
          machine_name: "appAContCitizenCountryId",
          widget: "select",
          label: "Country of Citizenship or Nationality",
          selection: data.country,
          validate: ["required", "noNAs"],
          maxLength: 70,
          tooltip: `Enter the foreign worker’s country of current citizenship.`,
        },
      ],
    },
  ],
};
